@for (tab of tabs; track tab) {
  <pr-tabs-item
    [tab]="tab"
    [withPlus]="withPlus"
    [variant]="variant"
  ></pr-tabs-item>
}
